module.exports = __webpack_public_path__ + "static/media/left-arrow.a851f5e7.svg";